export const ENGLISH_TRANSLATIONS: Record<string, string> = {
  downloadDefrag: 'Download Defrag',
  author: 'Author',
  ratingLeaders: 'Top players',
  player: 'Player',
  rating: 'Rating',
  loggedInAs: "You're logged in as",
  adminPanel: 'Admin panel',
  profile: 'Profile',
  logout: 'Logout',
  logIn: 'Log in',
  signUp: 'Sign up',
  mainPage: 'Home',
  rules: 'Rules',
  movies: 'Movies',
  wrDatabase: 'WR Database',
  comments: 'Comments',
  hideComments: 'Hide comments',
  writeComment: 'Write a comment',
  send: 'Send',
  loginOrRegisterToComment: 'Login or register to write a comment',
  map: 'Map',
  start: 'Start',
  finish: 'Finish',
  weapons: 'Weapons',
  download: 'Download',
  fullRules: 'Full rules',
  config: 'Config',
  upload: 'Upload',
  cupFinished: 'Event is finished',
  cupNotStarted: 'Event not started yet',
  loginOrRegister: 'Login or register',
  noUploadedDemos: 'No uploaded demos',
  time: 'Time',
  allDemosArchive: 'Download all demos in one archive',
  fullTable: 'Full table',
  myDemos: 'My demos',
  delete: 'Delete',
  confirmDelete: 'Confirm delete',
  demoValidationFailed: 'Demo validation failed',
  parameter: 'Parameter',
  actualValue: 'Actual value',
  requiredValue: 'Required value',
  listOfRegisteredPlayers: 'List of registered players',
  errorNewsDoesntExist: "Error - news doesn't exist",
  season: 'Season',
  ratingsBySeason: 'Ratings by season',
  youCanWatchFullRatingSystemDescription: 'You can watch full rating system description',
  here: 'here',
  currentSeasonRatingList: 'Rating list: current season',
  seasonRatingList: 'Rating list: season',
  defragMovies: 'Defrag movies',
  country: 'Country',
  playerProfile: 'Player profile:',
  rewards: 'Rewards',
  lastDemos: 'Last demos',
  tournamentParticipation: 'Tournament participation',
  tournamentName: 'Tournament name',
  physics: 'Physics',
  result: 'Result',
  place: 'Place',
  siteLogIn: 'Log in',
  userLogin: 'Login',
  password: 'Password',
  wrongLoginPassword: 'Wrong login/password',
  signUpOnSite: 'Sign up',
  fieldIsRequired: 'Field is required',
  confirmation: 'Confirmation',
  passwordsDoNotMatch: 'Passwords do not match',
  wrongEmailFormat: 'Wrong email format',
  loginAlreadyTaken: 'Login already taken',
  bonusRating: 'Bonus rating',
  ratingModifier: 'Rating modifier',
  daysShorthand: 'Days',
  starting: 'Starting',
  awaitingTournamentStart: 'Awaiting tournament start',
  finished: 'Finished',
  downloadMap: 'Download map',
  finishing: 'Finishing',
  error: 'Error',
  noDemo: 'No demo',
  wrongMap: 'Wrong map',
  uploadFailed: 'Upload failed',
  success: 'Success',
  demoSent: 'Demo sent',
  archive: 'News',
  allNews: 'All News',
  newsArchive: 'News archive',
  goToArchive: 'Go to news archive',
  fullResultsTable: 'Full results table',
  editProfile: 'Edit profile',
  nick: 'Nick',
  nickChangeMessage: 'Can be changed once per month, login remains the same',
  avatar: 'Avatar',
  avatarChangeMessage: 'Max size - 5MB',
  save: 'Save',
  registerForCup: 'Register for cup',
  cancelRegistration: 'Cancel registration',
  returnToMainpage: 'Return to mainpage',
  cancel: 'Cancel',
  editComment: 'Edit comment',
  twoMinutesError: '2 minutes have passed',
  cantModify: `Can't modify`,
  fillDeleteReason: 'Fill reason for deleting comment',
  reason: 'Reason',
  edit: 'Edit',
  commentDeletedByModerator: 'Comment was deleted by moderator. Reason:',
  personalSmiles: 'Personal',
  defragSmiles: 'Defrag',
  mainSmiles: 'Smileys & People',
  gestureSmiles: 'Gestures',
  foodSmiles: 'Food',
  animalsSmiles: 'Animals',
  miscSmiles: 'Miscellaneous',
  noSmilesFound: 'No smiles found',
  chosenSmile: 'Chosen smile',
  searchSmiles: 'Search smiles',
  oneVOne: '1v1',
  oneVOneMatches: '1v1 matches',
  waitingForQueue: 'Waiting for queue',
  playOneVersusOne: 'Play 1v1',
  inQueue: 'In queue',
  searchingForOpponent: 'Searching for opponent',
  cancelSearch: 'Cancel search',
  playNextMatch: 'Play next match',
  matchesPageOpenedElsewhere: 'Matches page is opened elsewhere',
  waitingForServerConnection: 'Waiting for server connection',
  registerToPlayMatches: 'Login or register to play 1v1 matches',
  matchInProgress: 'Match in progress',
  opponentIsBanningMap: 'Opponent is banning a map',
  youAreBanningMap: 'You are banning a map',
  uploadDemoWhenReady: 'Upload a demo when ready',
  yourBestTime: 'Your best time',
  matchFinished: 'Match is finished',
  wins: 'wins',
  draw: 'draw',
  showPrepostedNews: 'Show preposted news (7 days)',
  killobsWarning: 'Warning: overbounces are enabled',
  findOnevOne: 'Find 1v1 match',
  currentMatchesIn: 'Current matches in',
  playersInQueue: 'Players in queue -',
  code: 'Code',
  uploadDemo: 'Upload demo',
  difficulty: 'Difficulty',
  descriptionAndRules: 'Description and rules',
  downloadForValidation: 'Download all demos for validation',
  searchVQ3: 'Search VQ3',
  searchCPM: 'Search CPM',
  loginOrRegisterToPlay1v1: 'Log in or register to play 1v1 matches',
  logInWithPassword: 'Log in with password',
  logInWithDiscord: 'Log in with Discord',
  registerNewDiscordAccount: 'Register new Discord account',
  discordAccountNotFound:
    'The specified Discord account does not have a Dfcomps account associated with it. Register a new account?',
  yes: 'Yes',
  no: 'No',
  finishSignUp: 'Finish sign up',
  signUpOnlyWithDiscord: 'Registration on the site is currently only available through a Discord account',
  registerWithDiscord: 'Register with Discord',
  signUpLoginCaption: 'Select a login under which other users will see you on the site',
  doYouWantToLinkDiscord: 'Do you want to link Discord account to your profile?',
  linkDiscord: 'Link Discord',
  downloadStreamersArchive: 'Download demos archive for streamers',
  other: 'Other',
  openStreamersTimer: 'Open streamers timer',
  onlineCupMapAreNotSet: 'Online cup maps are not set yet',
  invalidDemos: 'Invalid demos',
  mapSuggestion: 'Map suggestion',
  suggestMapOnWarcup: 'Suggest a map for WarCup',
  mapWasNotFoundOnWS: `Map wasn't found on`,
  mapWasOnCompetition: 'Map was on',
  mapWasFoundOnWS: 'Map was found on',
  mapWasntOnCompetitions: `Map wasn't on dfcomps competitions`,
  mapSuggested: 'Map was sent as a suggestion for Warcup',
  suggestionGrayHint: 'Suggestion will be available again at the next warcup',
  seasonPeriod: '27 June 2026 - 26 December 2026',
  forMappers: 'For mappers',
  mappersSuggestionInfo: 'if you want to suggest your new map on warcup, write PM in Discord n0sf',
  score: 'Score',
  noReviews: 'No reviews',
  loginToAddReview: 'Log in or sign up to add review',
  averagePlace: 'Average place',
  firstPlaces: 'First places',
  secondPlaces: 'Second places',
  thirdPlaces: 'Third places',
  tournamentStats: 'Tournament stats',
  uploadWr: 'Upload WR',
  uploadWorldRecord: 'Upload World Record',
  itsMyDemo: `It's my demo`,
  useDfName: 'Use df_name from demo',
  selectFromUsers: 'Select from dfcomps users',
  uploadWrRules: `You can upload any demo on a map that does not yet have a demo uploaded, or a demo whose time is strictly lower than the current record on that map. Only settings from the standard config and the time resets are validated upon upload. All types of overbounces and the use of map-specific online mechanics are allowed, only demos with cheats will be removed.`,
  choosePlayer: 'Choose player',
  chooseDemo: 'Choose demo (.dm_68)',
  toUploadWr: 'to upload world records',
  filterByMapName: 'Filter by map name',
  noWrFound: 'No world records found',
  wrList: 'World Records List',
  date: 'Date',
  recentWorldRecords: 'Recent World Records',
};
